import { ApiClient } from '~config/http-api-config'
import CONFIG from '~config/env'
import { queryParam } from '@/config/queryParam'

const getAwsSignedUrl = (key, fileName) => ApiClient.get(CONFIG.API.ENDPOINTS.SIGNED_GET + '?key=' + key + '&fileName=' + fileName)
const getAwsMultipleSignedUrl = (keys, fileNames) =>
  ApiClient.get(CONFIG.API.ENDPOINTS.MULTIPLE_SIGNED_GET + '?keys=' + keys + '&fileNames=' + fileNames)
const getSignedDocumentsUrl = token => ApiClient.get(CONFIG.API.ENDPOINTS.SIGNED_DOCUMENTS_URL + '?token=' + token)
const getDashboardUrl = (dashboardId, filters) =>
  ApiClient.get(
    CONFIG.API.ENDPOINTS.BI_DASHBOARD_URL +
      queryParam({
        id: dashboardId,
        ...filters
      })
  )
const geocodeAddress = address =>
  ApiClient.get(
    CONFIG.API.ENDPOINTS.GEOCODE_ADDRESS.replace('{address}', address) +
      '?limit=1&language=pt&fuzzyMatch=true&country=BR&types=address&access_token=' +
      CONFIG.MAPBOX_PUBLIC_TOKEN
  )
const requestSignature = (senderName, projectId, documentId, documentName, documentUrl, defaultSigner, signers, extraDocuments) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.REQUEST_SIGNATURE, {
    senderName,
    projectId,
    documentId,
    documentName,
    documentUrl,
    defaultSigner,
    signers,
    extraDocuments
  })

const updateSignature = (documentId, signers) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.UPDATE_SIGNATURE, {
    documentId,
    signers
  })

const updateContractStatus = documentId =>
  ApiClient.post(CONFIG.API.ENDPOINTS.UPDATE_CONTRACT_STATUS, {
    documentId
  })

const aiExtractData = (documentId, forceExtractText, forceAiExecution) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.AI_EXTRACT_DATA, {
    documentId,
    forceExtractText,
    forceAiExecution
  })

const aiValidateDocument = (documentId, forceExtractText, forceAiExecution) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.AI_VALIDATE_DOCUMENT, {
    documentId,
    forceExtractText,
    forceAiExecution: true
  })

const setup2Fa = () => ApiClient.post(CONFIG.API.ENDPOINTS.SETUP_2FA)
const verify2Fa = token =>
  ApiClient.post(CONFIG.API.ENDPOINTS.VERIFY_2FA, {
    token
  })

const refreshBankAccount = bankAccountId =>
  ApiClient.post(CONFIG.API.ENDPOINTS.ASAAS_REFRESH_ACCOUNT, {
    bankAccountId
  })

const processPaymentBook = installmentGroupId => {
  const url = CONFIG.API.ENDPOINTS.PROCESS_PAYMENT_BOOK + `?installmentGroupId=${installmentGroupId}`
  return ApiClient.post(url)
}

const setProjectPartners = (projectId, projectPartners, reprocess = false) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.SET_PROJECT_PARTNERS, {
    projectId,
    projectPartners,
    reprocess
  })

const storeSecret = (token, refName, refId, properties) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.STORE_SECRET, {
    token,
    refName,
    refId,
    properties
  })

const updatePartnerIntegrations = partnerId => ApiClient.post(CONFIG.API.ENDPOINTS.UPDATE_PARTNER_INTEGRATIONS + queryParam({ partnerId }))

const manualPayment = (installmentId, paymentDate, observations) =>
  ApiClient.post(CONFIG.API.ENDPOINTS.FINANCE.MANUAL_PAYMENT, {
    installmentId,
    paymentDate,
    observations
  })

export default {
  setup2Fa,
  verify2Fa,
  storeSecret,
  getAwsSignedUrl,
  getAwsMultipleSignedUrl,
  getSignedDocumentsUrl,
  requestSignature,
  updateSignature,
  updateContractStatus,
  getDashboardUrl,
  aiExtractData,
  aiValidateDocument,
  geocodeAddress,
  refreshBankAccount,
  setProjectPartners,
  processPaymentBook,
  updatePartnerIntegrations,
  manualPayment
}
